import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  pt: {
    translation: {
      // Auth
      login: 'Entrar',
      logout: 'Sair',
      username: 'Usuário',
      password: 'Senha',
      fullName: 'Nome Completo',
      email: 'E-mail',
      register: 'Cadastrar',
      welcomeBack: 'Bem-vindo de volta',
      loginSubtitle: 'Entre no painel de controle Octopus',
      invalidCredentials: 'Credenciais inválidas',
      accountPendingApproval: 'Seu cadastro ainda está aguardando aprovação. Você receberá um e-mail quando for aprovado.',
      accountRejected: 'Seu cadastro não foi aprovado. Entre em contato com o administrador.',
      accountDisabled: 'Sua conta está desativada. Entre em contato com o administrador.',
      or: 'ou',
      createAccount: 'Criar sua conta',
      alreadyHaveAccount: 'Já tenho uma conta',
      
      // Sign Up
      signUp: 'Criar Conta',
      signUpSubtitle: 'Preencha seus dados para solicitar acesso ao sistema',
      cpf: 'CPF',
      phone: 'Telefone',
      birthDate: 'Data de Nascimento',
      department: 'Departamento',
      selectDepartment: 'Selecione seu departamento',
      confirmPasswordLabel: 'Confirmar Senha',
      termsAccept: 'Li e aceito os termos de uso e política de privacidade do sistema.',
      requestSignUp: 'Solicitar Cadastro',
      signUpSuccess: 'Cadastro Enviado!',
      signUpSuccessMessage: 'Sua solicitação foi recebida e está aguardando aprovação. Você receberá um e-mail quando sua conta for ativada.',
      backToLoginBtn: 'Voltar para o Login',
      sending: 'Enviando...',
      
      // Validation errors
      nameMinLength: 'Nome deve ter pelo menos 3 caracteres',
      invalidCpf: 'CPF inválido',
      invalidEmail: 'E-mail inválido',
      invalidPhone: 'Telefone inválido',
      birthDateRequired: 'Data de nascimento é obrigatória',
      minAge: 'Idade mínima de 16 anos',
      selectDepartmentError: 'Selecione um departamento',
      passwordMinChars: 'Senha deve ter pelo menos 6 caracteres',
      passwordsDontMatch: 'Senhas não conferem',
      acceptTermsError: 'Você deve aceitar os termos',
      cpfAlreadyExists: 'CPF já cadastrado no sistema',
      emailAlreadyExists: 'E-mail já cadastrado no sistema',
      
      // Password Recovery
      forgotPassword: 'Esqueci minha senha',
      forgotPasswordDescription: 'Digite seu e-mail cadastrado para receber um link de recuperação de senha.',
      sendResetEmail: 'Enviar link',
      resetEmailSent: 'Se o e-mail estiver cadastrado, você receberá um link de recuperação em breve.',
      resetEmailSentDescription: 'Verifique sua caixa de entrada e spam.',
      backToLogin: 'Voltar para o login',
      resetPassword: 'Redefinir Senha',
      resetPasswordDescription: 'Digite sua nova senha abaixo.',
      newPassword: 'Nova Senha',
      confirmPassword: 'Confirmar Senha',
      passwordTooShort: 'A senha deve ter no mínimo 8 caracteres, com letras e números',
      passwordsDoNotMatch: 'As senhas não conferem',
      passwordMinLength: 'Mínimo de 8 caracteres, com letras e números',
      passwordChanged: 'Senha Alterada!',
      passwordChangedSuccess: 'Sua senha foi alterada com sucesso',
      passwordChangedDescription: 'Você já pode fazer login com sua nova senha.',
      invalidOrExpiredToken: 'Link Inválido ou Expirado',
      invalidOrExpiredTokenDescription: 'Este link de recuperação é inválido ou já expirou. Solicite um novo link na página de login.',
      verifyingToken: 'Verificando link...',
      
      // Navigation
      dashboard: 'Dashboard',
      equipments: 'Equipamentos',
      equipmentsList: 'Lista de Equipamentos',
      equipmentGroups: 'Grupos de Equipamentos',
      equipmentTypes: 'Tipos de Equipamentos',
      users: 'Usuários',
      settings: 'Configurações',
      administration: 'Administração',
      
      // Equipment
      addEquipment: 'Adicionar Equipamento',
      editEquipment: 'Editar Equipamento',
      deleteEquipment: 'Excluir Equipamento',
      equipmentName: 'Nome do Equipamento',
      equipmentTag: 'Tag do Equipamento',
      equipmentType: 'Tipo de Equipamento',
      locationType: 'Tipo de Localização',
      gpsLocation: 'GPS Dinâmico',
      fixedLocation: 'Localização Fixa',
      latitude: 'Latitude',
      longitude: 'Longitude',
      mqttTopic: 'Tópico MQTT',
      mqttClientId: 'Client ID MQTT',
      description: 'Descrição',
      status: 'Status',
      online: 'Online',
      offline: 'Offline',
      awaitingInitialConnection: 'Aguardando Conexão Inicial',
      lastSeen: 'Última Vez Visto',
      lastUpdate: 'Última atualização',
      noEquipments: 'Nenhum equipamento cadastrado',
      
      // Equipment Types
      addEquipmentType: 'Adicionar Tipo',
      editEquipmentType: 'Editar Tipo',
      deleteEquipmentType: 'Excluir Tipo',
      typeName: 'Nome do Tipo',
      typeIcon: 'Ícone',
      noEquipmentTypes: 'Nenhum tipo cadastrado',
      
      // Users
      addUser: 'Adicionar Usuário',
      editUser: 'Editar Usuário',
      deleteUser: 'Excluir Usuário',
      language: 'Idioma',
      portuguese: 'Português',
      english: 'Inglês',
      spanish: 'Espanhol',
      noUsers: 'Nenhum usuário cadastrado',
      role: 'Função',
      administrator: 'Administrador',
      normalUser: 'Usuário Normal',
      roleDescription: 'Administradores têm acesso às configurações do sistema',
      
      // Actions
      save: 'Salvar',
      cancel: 'Cancelar',
      delete: 'Excluir',
      edit: 'Editar',
      add: 'Adicionar',
      search: 'Buscar',
      filter: 'Filtrar',
      confirm: 'Confirmar',
      close: 'Fechar',
      
      // Messages
      success: 'Sucesso',
      error: 'Erro',
      confirmDelete: 'Tem certeza que deseja excluir?',
      deleteSuccess: 'Excluído com sucesso',
      saveSuccess: 'Salvo com sucesso',
      errorOccurred: 'Ocorreu um erro',
      
      // Map
      setLocationOnMap: 'Clique no mapa para definir a localização',
      dragMarker: 'Arraste o marcador para ajustar a posição',
      totalEquipments: 'Total de Equipamentos',
      onlineEquipments: 'Equipamentos Online',
      offlineEquipments: 'Equipamentos Offline',
      awaitingEquipments: 'Aguardando Conexão',
      
      // MQTT
      mqttCredentials: 'Credenciais MQTT',
      mqttUsername: 'Usuário MQTT',
      mqttPassword: 'Senha MQTT',
      mqttTopicBase: 'Tópico Base',
      brokerConnection: 'Conexão com Broker',
      port: 'Porta',
      generateCredentials: 'Gerar Credenciais',
      regenerateCredentials: 'Regenerar Credenciais',
      regenerate: 'Regenerar',
      killConnection: 'Forçar Desconexão',
      disconnect: 'Desconectar',
      downloadConfig: 'Baixar Configuração',
      configDownloaded: 'Configuração baixada',
      copiedToClipboard: 'copiado',
      noMqttCredentials: 'Credenciais MQTT não geradas',
      mqttCredentialsRegenerated: 'Credenciais regeneradas com sucesso',
      mqttClientKicked: 'Comando de desconexão enviado',
      mqttServiceNotConnected: 'Serviço MQTT não conectado',
      sharedCredentialsInfo: 'Credenciais compartilhadas. A distinção dos equipamentos é feita pelo Client ID e Tópico.',
      killConnectionWarning: 'Isso enviará um comando de desconexão ao dispositivo. Ele poderá reconectar automaticamente se estiver configurado para isso.',
      
      // Alerts
      alertCenter: 'Central de Alertas',
      activeAlerts: 'ativo',
      activeAlertsPlural: 'ativos',
      noAlerts: 'Nenhum alerta',
      alertsActive: 'ATIVOS',
      alertsAcknowledged: 'CIENTES',
      alertsResolved: 'ENCERRADOS',
      alertsResolvedLast: 'últimos 10',
      acknowledge: 'Ciente',
      resolve: 'Encerrar',
      now: 'Agora',
      minutesAgo: 'min atrás',
      hoursAgo: 'h atrás',
      
      // MQTT Server Settings
      mqttServerSettings: 'Configurações do Servidor MQTT',
      mqttServerDescription: 'Configure a conexão com seu broker MQTT (Mosquitto)',
      mqttBrokerHost: 'Host do Broker',
      mqttBrokerPort: 'Porta',
      mqttAdminUser: 'Usuário Admin',
      mqttAdminPassword: 'Senha Admin',
      mqttUseTls: 'Usar TLS/SSL',
      mqttTestConnection: 'Testar Conexão',
      mqttConnectionSuccess: 'Conexão com broker MQTT estabelecida',
      mqttConnectionFailed: 'Falha na conexão com broker MQTT',
    }
  },
  en: {
    translation: {
      // Auth
      login: 'Login',
      logout: 'Logout',
      username: 'Username',
      password: 'Password',
      fullName: 'Full Name',
      email: 'Email',
      register: 'Register',
      welcomeBack: 'Welcome Back',
      loginSubtitle: 'Sign in to Octopus control panel',
      invalidCredentials: 'Invalid credentials',
      accountPendingApproval: 'Your registration is still pending approval. You will receive an email when approved.',
      accountRejected: 'Your registration was not approved. Please contact the administrator.',
      accountDisabled: 'Your account is disabled. Please contact the administrator.',
      or: 'or',
      createAccount: 'Create your account',
      alreadyHaveAccount: 'Already have an account',
      
      // Sign Up
      signUp: 'Create Account',
      signUpSubtitle: 'Fill in your details to request access to the system',
      cpf: 'CPF',
      phone: 'Phone',
      birthDate: 'Birth Date',
      department: 'Department',
      selectDepartment: 'Select your department',
      confirmPasswordLabel: 'Confirm Password',
      termsAccept: 'I have read and accept the terms of use and privacy policy.',
      requestSignUp: 'Request Registration',
      signUpSuccess: 'Registration Sent!',
      signUpSuccessMessage: 'Your request has been received and is awaiting approval. You will receive an email when your account is activated.',
      backToLoginBtn: 'Back to Login',
      sending: 'Sending...',
      
      // Validation errors
      nameMinLength: 'Name must have at least 3 characters',
      invalidCpf: 'Invalid CPF',
      invalidEmail: 'Invalid email',
      invalidPhone: 'Invalid phone',
      birthDateRequired: 'Birth date is required',
      minAge: 'Minimum age of 16 years',
      selectDepartmentError: 'Select a department',
      passwordMinChars: 'Password must have at least 6 characters',
      passwordsDontMatch: 'Passwords do not match',
      acceptTermsError: 'You must accept the terms',
      cpfAlreadyExists: 'CPF already registered',
      emailAlreadyExists: 'Email already registered',
      
      // Password Recovery
      forgotPassword: 'Forgot password',
      forgotPasswordDescription: 'Enter your registered email to receive a password reset link.',
      sendResetEmail: 'Send link',
      resetEmailSent: 'If the email is registered, you will receive a recovery link shortly.',
      resetEmailSentDescription: 'Check your inbox and spam folder.',
      backToLogin: 'Back to login',
      resetPassword: 'Reset Password',
      resetPasswordDescription: 'Enter your new password below.',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      passwordTooShort: 'Password must be at least 8 characters, with letters and numbers',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordMinLength: 'Minimum 8 characters, with letters and numbers',
      passwordChanged: 'Password Changed!',
      passwordChangedSuccess: 'Your password has been changed successfully',
      passwordChangedDescription: 'You can now login with your new password.',
      invalidOrExpiredToken: 'Invalid or Expired Link',
      invalidOrExpiredTokenDescription: 'This recovery link is invalid or has expired. Request a new link on the login page.',
      verifyingToken: 'Verifying link...',
      
      // Navigation
      dashboard: 'Dashboard',
      equipments: 'Equipment',
      equipmentsList: 'Equipment List',
      equipmentGroups: 'Equipment Groups',
      equipmentTypes: 'Equipment Types',
      users: 'Users',
      settings: 'Settings',
      administration: 'Administration',
      
      // Equipment
      addEquipment: 'Add Equipment',
      editEquipment: 'Edit Equipment',
      deleteEquipment: 'Delete Equipment',
      equipmentName: 'Equipment Name',
      equipmentTag: 'Equipment Tag',
      equipmentType: 'Equipment Type',
      locationType: 'Location Type',
      gpsLocation: 'Dynamic GPS',
      fixedLocation: 'Fixed Location',
      latitude: 'Latitude',
      longitude: 'Longitude',
      mqttTopic: 'MQTT Topic',
      mqttClientId: 'MQTT Client ID',
      description: 'Description',
      status: 'Status',
      online: 'Online',
      offline: 'Offline',
      awaitingInitialConnection: 'Awaiting Initial Connection',
      lastSeen: 'Last Seen',
      lastUpdate: 'Last update',
      noEquipments: 'No equipment registered',
      
      // Equipment Types
      addEquipmentType: 'Add Type',
      editEquipmentType: 'Edit Type',
      deleteEquipmentType: 'Delete Type',
      typeName: 'Type Name',
      typeIcon: 'Icon',
      noEquipmentTypes: 'No types registered',
      
      // Users
      addUser: 'Add User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      language: 'Language',
      portuguese: 'Portuguese',
      english: 'English',
      spanish: 'Spanish',
      noUsers: 'No users registered',
      role: 'Role',
      administrator: 'Administrator',
      normalUser: 'Normal User',
      roleDescription: 'Administrators have access to system settings',
      
      // Actions
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      filter: 'Filter',
      confirm: 'Confirm',
      close: 'Close',
      
      // Messages
      success: 'Success',
      error: 'Error',
      confirmDelete: 'Are you sure you want to delete?',
      deleteSuccess: 'Deleted successfully',
      saveSuccess: 'Saved successfully',
      errorOccurred: 'An error occurred',
      
      // Map
      setLocationOnMap: 'Click on the map to set location',
      dragMarker: 'Drag the marker to adjust position',
      totalEquipments: 'Total Equipment',
      onlineEquipments: 'Online Equipment',
      offlineEquipments: 'Offline Equipment',
      awaitingEquipments: 'Awaiting Connection',
      
      // MQTT
      mqttCredentials: 'MQTT Credentials',
      mqttUsername: 'MQTT Username',
      mqttPassword: 'MQTT Password',
      mqttTopicBase: 'Topic Base',
      brokerConnection: 'Broker Connection',
      port: 'Port',
      generateCredentials: 'Generate Credentials',
      regenerateCredentials: 'Regenerate Credentials',
      regenerate: 'Regenerate',
      killConnection: 'Kill Connection',
      disconnect: 'Disconnect',
      downloadConfig: 'Download Config',
      configDownloaded: 'Configuration downloaded',
      copiedToClipboard: 'copied',
      noMqttCredentials: 'MQTT credentials not generated',
      mqttCredentialsRegenerated: 'Credentials regenerated successfully',
      mqttClientKicked: 'Disconnect command sent',
      mqttServiceNotConnected: 'MQTT service not connected',
      sharedCredentialsInfo: 'Shared credentials. Equipment is distinguished by Client ID and Topic.',
      killConnectionWarning: 'This will send a disconnect command to the device. It may reconnect automatically if configured to do so.',
      
      // Alerts
      alertCenter: 'Alert Center',
      activeAlerts: 'active',
      activeAlertsPlural: 'active',
      noAlerts: 'No alerts',
      alertsActive: 'ACTIVE',
      alertsAcknowledged: 'ACKNOWLEDGED',
      alertsResolved: 'RESOLVED',
      alertsResolvedLast: 'last 10',
      acknowledge: 'Acknowledge',
      resolve: 'Resolve',
      now: 'Now',
      minutesAgo: 'min ago',
      hoursAgo: 'h ago',
      
      // MQTT Server Settings
      mqttServerSettings: 'MQTT Server Settings',
      mqttServerDescription: 'Configure the connection to your MQTT broker (Mosquitto)',
      mqttBrokerHost: 'Broker Host',
      mqttBrokerPort: 'Port',
      mqttAdminUser: 'Admin Username',
      mqttAdminPassword: 'Admin Password',
      mqttUseTls: 'Use TLS/SSL',
      mqttTestConnection: 'Test Connection',
      mqttConnectionSuccess: 'Connection to MQTT broker established',
      mqttConnectionFailed: 'Failed to connect to MQTT broker',
    }
  },
  es: {
    translation: {
      // Auth
      login: 'Iniciar Sesión',
      logout: 'Cerrar Sesión',
      username: 'Usuario',
      password: 'Contraseña',
      fullName: 'Nombre Completo',
      email: 'Correo electrónico',
      register: 'Registrar',
      welcomeBack: 'Bienvenido',
      loginSubtitle: 'Inicia sesión en el panel de control Octopus',
      invalidCredentials: 'Credenciales inválidas',
      accountPendingApproval: 'Su registro aún está pendiente de aprobación. Recibirá un correo cuando sea aprobado.',
      accountRejected: 'Su registro no fue aprobado. Contacte al administrador.',
      accountDisabled: 'Su cuenta está desactivada. Contacte al administrador.',
      or: 'o',
      createAccount: 'Crear su cuenta',
      alreadyHaveAccount: 'Ya tengo una cuenta',
      
      // Sign Up
      signUp: 'Crear Cuenta',
      signUpSubtitle: 'Complete sus datos para solicitar acceso al sistema',
      cpf: 'CPF',
      phone: 'Teléfono',
      birthDate: 'Fecha de Nacimiento',
      department: 'Departamento',
      selectDepartment: 'Seleccione su departamento',
      confirmPasswordLabel: 'Confirmar Contraseña',
      termsAccept: 'He leído y acepto los términos de uso y política de privacidad.',
      requestSignUp: 'Solicitar Registro',
      signUpSuccess: '¡Registro Enviado!',
      signUpSuccessMessage: 'Su solicitud fue recibida y está pendiente de aprobación. Recibirá un correo cuando su cuenta sea activada.',
      backToLoginBtn: 'Volver al Login',
      sending: 'Enviando...',
      
      // Validation errors
      nameMinLength: 'El nombre debe tener al menos 3 caracteres',
      invalidCpf: 'CPF inválido',
      invalidEmail: 'Correo inválido',
      invalidPhone: 'Teléfono inválido',
      birthDateRequired: 'Fecha de nacimiento es obligatoria',
      minAge: 'Edad mínima de 16 años',
      selectDepartmentError: 'Seleccione un departamento',
      passwordMinChars: 'La contraseña debe tener al menos 6 caracteres',
      passwordsDontMatch: 'Las contraseñas no coinciden',
      acceptTermsError: 'Debe aceptar los términos',
      cpfAlreadyExists: 'CPF ya registrado',
      emailAlreadyExists: 'Correo ya registrado',
      
      // Password Recovery
      forgotPassword: 'Olvidé mi contraseña',
      forgotPasswordDescription: 'Ingresa tu correo registrado para recibir un enlace de recuperación.',
      sendResetEmail: 'Enviar enlace',
      resetEmailSent: 'Si el correo está registrado, recibirás un enlace de recuperación pronto.',
      resetEmailSentDescription: 'Revisa tu bandeja de entrada y spam.',
      backToLogin: 'Volver al login',
      resetPassword: 'Restablecer Contraseña',
      resetPasswordDescription: 'Ingresa tu nueva contraseña abajo.',
      newPassword: 'Nueva Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      passwordTooShort: 'La contraseña debe tener al menos 8 caracteres, con letras y números',
      passwordsDoNotMatch: 'Las contraseñas no coinciden',
      passwordMinLength: 'Mínimo 8 caracteres, con letras y números',
      passwordChanged: '¡Contraseña Cambiada!',
      passwordChangedSuccess: 'Tu contraseña ha sido cambiada con éxito',
      passwordChangedDescription: 'Ya puedes iniciar sesión con tu nueva contraseña.',
      invalidOrExpiredToken: 'Enlace Inválido o Expirado',
      invalidOrExpiredTokenDescription: 'Este enlace de recuperación es inválido o ha expirado. Solicita un nuevo enlace en la página de login.',
      verifyingToken: 'Verificando enlace...',
      
      // Navigation
      dashboard: 'Panel',
      equipments: 'Equipos',
      equipmentsList: 'Lista de Equipos',
      equipmentGroups: 'Grupos de Equipos',
      equipmentTypes: 'Tipos de Equipos',
      users: 'Usuarios',
      settings: 'Configuración',
      administration: 'Administración',
      
      // Equipment
      addEquipment: 'Agregar Equipo',
      editEquipment: 'Editar Equipo',
      deleteEquipment: 'Eliminar Equipo',
      equipmentName: 'Nombre del Equipo',
      equipmentTag: 'Tag del Equipo',
      equipmentType: 'Tipo de Equipo',
      locationType: 'Tipo de Ubicación',
      gpsLocation: 'GPS Dinámico',
      fixedLocation: 'Ubicación Fija',
      latitude: 'Latitud',
      longitude: 'Longitud',
      mqttTopic: 'Tema MQTT',
      mqttClientId: 'Client ID MQTT',
      description: 'Descripción',
      status: 'Estado',
      online: 'En Línea',
      offline: 'Fuera de Línea',
      awaitingInitialConnection: 'Esperando Conexión Inicial',
      lastSeen: 'Última Vez Visto',
      lastUpdate: 'Última actualización',
      noEquipments: 'No hay equipos registrados',
      
      // Equipment Types
      addEquipmentType: 'Agregar Tipo',
      editEquipmentType: 'Editar Tipo',
      deleteEquipmentType: 'Eliminar Tipo',
      typeName: 'Nombre del Tipo',
      typeIcon: 'Icono',
      noEquipmentTypes: 'No hay tipos registrados',
      
      // Users
      addUser: 'Agregar Usuario',
      editUser: 'Editar Usuario',
      deleteUser: 'Eliminar Usuario',
      language: 'Idioma',
      portuguese: 'Portugués',
      english: 'Inglés',
      spanish: 'Español',
      noUsers: 'No hay usuarios registrados',
      role: 'Rol',
      administrator: 'Administrador',
      normalUser: 'Usuario Normal',
      roleDescription: 'Los administradores tienen acceso a la configuración del sistema',
      
      // Actions
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      add: 'Agregar',
      search: 'Buscar',
      filter: 'Filtrar',
      confirm: 'Confirmar',
      close: 'Cerrar',
      
      // Messages
      success: 'Éxito',
      error: 'Error',
      confirmDelete: '¿Está seguro de que desea eliminar?',
      deleteSuccess: 'Eliminado con éxito',
      saveSuccess: 'Guardado con éxito',
      errorOccurred: 'Ocurrió un error',
      
      // Map
      setLocationOnMap: 'Haz clic en el mapa para establecer la ubicación',
      dragMarker: 'Arrastra el marcador para ajustar la posición',
      totalEquipments: 'Total de Equipos',
      onlineEquipments: 'Equipos En Línea',
      offlineEquipments: 'Equipos Fuera de Línea',
      awaitingEquipments: 'Esperando Conexión',
      
      // MQTT
      mqttCredentials: 'Credenciales MQTT',
      mqttUsername: 'Usuario MQTT',
      mqttPassword: 'Contraseña MQTT',
      mqttTopicBase: 'Tema Base',
      brokerConnection: 'Conexión al Broker',
      port: 'Puerto',
      generateCredentials: 'Generar Credenciales',
      regenerateCredentials: 'Regenerar Credenciales',
      regenerate: 'Regenerar',
      killConnection: 'Forzar Desconexión',
      disconnect: 'Desconectar',
      downloadConfig: 'Descargar Config',
      configDownloaded: 'Configuración descargada',
      copiedToClipboard: 'copiado',
      noMqttCredentials: 'Credenciales MQTT no generadas',
      mqttCredentialsRegenerated: 'Credenciales regeneradas con éxito',
      mqttClientKicked: 'Comando de desconexión enviado',
      mqttServiceNotConnected: 'Servicio MQTT no conectado',
      sharedCredentialsInfo: 'Credenciales compartidas. Los equipos se distinguen por Client ID y Tópico.',
      killConnectionWarning: 'Esto enviará un comando de desconexión al dispositivo. Puede reconectarse automáticamente si está configurado para ello.',
      
      // Alerts
      alertCenter: 'Centro de Alertas',
      activeAlerts: 'activo',
      activeAlertsPlural: 'activos',
      noAlerts: 'Sin alertas',
      alertsActive: 'ACTIVOS',
      alertsAcknowledged: 'RECONOCIDOS',
      alertsResolved: 'RESUELTOS',
      alertsResolvedLast: 'últimos 10',
      acknowledge: 'Reconocer',
      resolve: 'Resolver',
      now: 'Ahora',
      minutesAgo: 'min atrás',
      hoursAgo: 'h atrás',
      
      // MQTT Server Settings
      mqttServerSettings: 'Configuración del Servidor MQTT',
      mqttServerDescription: 'Configure la conexión con su broker MQTT (Mosquitto)',
      mqttBrokerHost: 'Host del Broker',
      mqttBrokerPort: 'Puerto',
      mqttAdminUser: 'Usuario Admin',
      mqttAdminPassword: 'Contraseña Admin',
      mqttUseTls: 'Usar TLS/SSL',
      mqttTestConnection: 'Probar Conexión',
      mqttConnectionSuccess: 'Conexión con broker MQTT establecida',
      mqttConnectionFailed: 'Error al conectar con broker MQTT',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    }
  });

// Função para detectar idioma por IP (geolocalização)
export const detectLanguageByIP = async () => {
  // Se já tiver idioma salvo no localStorage, não alterar
  const savedLang = localStorage.getItem('i18nextLng');
  if (savedLang) return savedLang;
  
  try {
    // Usar API gratuita de geolocalização
    const response = await fetch('https://ipapi.co/json/', { 
      timeout: 3000,
      cache: 'no-store' 
    });
    
    if (!response.ok) throw new Error('Failed to fetch');
    
    const data = await response.json();
    const countryCode = data.country_code?.toUpperCase();
    
    // Mapeamento de países para idiomas
    const countryToLang = {
      'BR': 'pt',
      'PT': 'pt',
      'AO': 'pt', // Angola
      'MZ': 'pt', // Moçambique
      'ES': 'es',
      'MX': 'es',
      'AR': 'es',
      'CO': 'es',
      'CL': 'es',
      'PE': 'es',
      'VE': 'es',
      // Todos os outros países = inglês
    };
    
    const detectedLang = countryToLang[countryCode] || 'en';
    
    // Salvar e aplicar
    localStorage.setItem('i18nextLng', detectedLang);
    i18n.changeLanguage(detectedLang);
    
    return detectedLang;
  } catch (error) {
    console.log('IP detection failed, using navigator language');
    return i18n.language;
  }
};

export default i18n;
